// import React, { useState } from "react";
// import {
//   TextField,
//   Button,
//   Container,
//   Grid,
//   Checkbox,
//   FormControlLabel,
//   Typography,
//   Box,
//   DatePicker,
// } from "@mui/material";

// import axios from "axios";

// function AddBeauty() {
//   const API_URL = process.env.REACT_APP_API_URL;
//   const [formData, setFormData] = useState({
//     user_id: "",
//     beautysubcategory_name: "",
//     beautycategory_name: "",
//     post_name: "",
//     // mealType_name: "",
//     beautytitle_name: "",
//     totalrating: "",
//     totalreviewrecipe_message: "",
//     url: "",
//     // difficulty_level: "",
//     // dietary_info: "",
//     // cuisine: "",
//     short_description: "",
//     author_name: "",
//     likes: "",
//     tags: [],
//     views: "",
//     body: "",
//     faqs: "",
//     summary: "",
//     created_at: new Date(),
//     updated_at: new Date(),
//     is_featured: false,
//   });

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${API_URL}/beauty/addbeautywithdetails`,
//         formData
//       );
//       alert(response.data.message);
//     } catch (error) {
//       alert("Error: " + error.response.data.message);
//     }
//   };

//   return (
//     <Container>
//       <Typography variant="h4" gutterBottom>
//         Add a Recipe
//       </Typography>
//       <form onSubmit={handleSubmit}>
//         <Grid container spacing={3}>
//           {/* User ID */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="User ID"
//               name="user_id"
//               value={formData.user_id}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           {/* Category ID */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="sub Category"
//               name="beautysubcategory_name"
//               value={formData.beautysubcategory_name}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>
//           <Grid item xs={12} sm={6}>
//             <TextField
//               type="number"
//               label="Total Rating"
//               name="totalrating"
//               value={formData.totalrating}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           <Grid item xs={12} sm={6}>
//             <TextField
//               type="number"
//               label="review message"
//               name="totalreviewrecipe_message"
//               value={formData.totalreviewrecipe_message}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           {/* Category Name */}
//           <Grid item xs={12}>
//             <TextField
//               label="Category Name"
//               name="beautycategory_name"
//               value={formData.beautycategory_name}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           {/* Post Name */}
//           {/* <Grid item xs={12}>
//             <TextField
//               label="Post Name"
//               name="post_name"
//               value={formData.post_name}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid> */}

//           {/* Meal Type */}
//           {/* <Grid item xs={12} sm={6}>
//             <TextField
//               label="Meal Type"
//               name="mealType_name"
//               value={formData.mealType_name}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid> */}

//           {/* Title Name */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="Title Name"
//               name="beautytitle_name"
//               value={formData.beautytitle_name}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           {/* Short Description */}
//           <Grid item xs={12}>
//             <TextField
//               label="Short Description"
//               name="short_description"
//               value={formData.short_description}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           {/* Author Name */}
//           <Grid item xs={12}>
//             <TextField
//               label="Author Name"
//               name="author_name"
//               value={formData.author_name}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//           </Grid>

//           {/* Difficulty Level */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="Body"
//               name="body"
//               value={formData.body}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           {/* Dietary Info */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="FAQS"
//               name="faqs"
//               value={formData.faqs}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           {/* summary */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="summary"
//               name="summary"
//               value={formData.summary}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           {/* URL */}
//           <Grid item xs={12}>
//             <TextField
//               label="URL"
//               name="url"
//               value={formData.url}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           {/* Tags */}
//           <Grid item xs={12}>
//             <TextField
//               label="Tags (comma separated)"
//               name="tags"
//               value={formData.tags.join(", ")}
//               onChange={(e) =>
//                 setFormData({
//                   ...formData,
//                   tags: e.target.value.split(",").map((tag) => tag.trim()),
//                 })
//               }
//               fullWidth
//             />
//           </Grid>

//           {/* Views */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="Views"
//               name="views"
//               value={formData.views}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           {/* Likes */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               label="Likes"
//               name="likes"
//               value={formData.likes}
//               onChange={handleChange}
//               fullWidth
//             />
//           </Grid>

//           {/* <Grid item xs={12} md={6}>
//             <TextField
//               label="Created At"
//               type="datetime-local"
//               variant="outlined"
//               fullWidth
//               name="created_at"
//               value={formData.created_at}
//               onChange={handleChange}
//               required
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Updated At"
//               type="datetime-local"
//               variant="outlined"
//               fullWidth
//               name="updated_at"
//               value={formData.updated_at}
//               onChange={handleChange}
//               InputLabelProps={{ shrink: true }}
//             />
//           </Grid> */}

//           {/* Date Picker for Created At */}

//           {/* Date Picker for Updated At */}

//           {/* Featured Checkbox */}
//           <Grid item xs={12}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={formData.is_featured}
//                   onChange={handleChange}
//                   name="is_featured"
//                 />
//               }
//               label="Is Featured?"
//             />
//           </Grid>

//           {/* Submit Button */}
//           <Grid item xs={12}>
//             <Button type="submit" variant="contained" color="primary" fullWidth>
//               Add Recipe
//             </Button>
//           </Grid>
//         </Grid>
//       </form>
//     </Container>
//   );
// }

// export default AddBeauty;

import React, { useState } from "react";
import {
  TextField,
  Button,
  Container,
  Grid,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import axios from "axios";

function AddBeauty() {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    user_id: "",
    beautysubcategory_name: "",
    beautycategory_name: "",
    // post_name: "",
    beautytitle_name: "",
    totalrating: "",
    totalreviewrecipe_message: "",
    url: "",
    short_description: "",
    author_name: "",
    likes: "",
    tags: [],
    views: "",
    body: "", // expects JSON string
    faqs: "", // expects JSON string
    summary: "",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    is_featured: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTagsChange = (e) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      tags: value
        .split(",")
        .map((tag) => tag.trim())
        .filter(Boolean),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let parsedBody, parsedFaqs;

    try {
      parsedBody = JSON.parse(formData.body);
    } catch (error) {
      alert("Invalid JSON in 'Body' field. Please correct it.");
      return;
    }

    try {
      parsedFaqs = JSON.parse(formData.faqs);
    } catch (error) {
      alert("Invalid JSON in 'FAQs' field. Please correct it.");
      return;
    }

    const payload = {
      ...formData,
      body: parsedBody,
      faqs: parsedFaqs,
    };

    try {
      const response = await axios.post(
        `${API_URL}/beauty/addbeautywithdetails`,
        payload
      );
      alert("Success: " + response.data.message);
    } catch (error) {
      console.error(error);
      alert("Error: " + (error.response?.data?.message || error.message));
    }
  };

  return (
    <Container>
      <Typography variant="h4" gutterBottom>
        Add Beauty Post
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          {/* User Info */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="User ID"
              name="user_id"
              value={formData.user_id}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Categories */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Subcategory Name"
              name="beautysubcategory_name"
              value={formData.beautysubcategory_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Category Name"
              name="beautycategory_name"
              value={formData.beautycategory_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>

          {/* Title and Description */}
          {/* <Grid item xs={12} sm={6}>
            <TextField
              label="Post Name"
              name="post_name"
              value={formData.post_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid> */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Title Name"
              name="beautytitle_name"
              value={formData.beautytitle_name}
              onChange={handleChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Short Description"
              name="short_description"
              value={formData.short_description}
              onChange={handleChange}
              fullWidth
              multiline
            />
          </Grid>

          {/* Rating & Reviews */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Total Rating"
              name="totalrating"
              value={formData.totalrating}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Total Review Messages"
              name="totalreviewrecipe_message"
              value={formData.totalreviewrecipe_message}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>

          {/* Media & Author */}
          <Grid item xs={12}>
            <TextField
              label="Image URL"
              name="url"
              value={formData.url}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Author Name"
              name="author_name"
              value={formData.author_name}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {/* Engagement */}
          <Grid item xs={12} sm={6}>
            <TextField
              label="Views"
              name="views"
              value={formData.views}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Likes"
              name="likes"
              value={formData.likes}
              onChange={handleChange}
              type="number"
              fullWidth
            />
          </Grid>

          {/* Tags */}
          <Grid item xs={12}>
            <TextField
              label="Tags (comma separated)"
              name="tags"
              value={formData.tags.join(", ")}
              onChange={handleTagsChange}
              fullWidth
            />
          </Grid>

          {/* Summary */}
          <Grid item xs={12}>
            <TextField
              label="Summary"
              name="summary"
              value={formData.summary}
              onChange={handleChange}
              fullWidth
              multiline
            />
          </Grid>

          {/* JSON Inputs */}
          <Grid item xs={12}>
            <TextField
              label="Body (JSON Array)"
              name="body"
              value={formData.body}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5}
              placeholder='[{"ingredients": "...", "instructions": "..."}]'
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="FAQs (JSON Array)"
              name="faqs"
              value={formData.faqs}
              onChange={handleChange}
              fullWidth
              multiline
              minRows={5}
              placeholder='[{"question": "...", "answer": "..."}]'
            />
          </Grid>

          {/* Featured */}
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.is_featured}
                  onChange={handleChange}
                  name="is_featured"
                />
              }
              label="Is Featured?"
            />
          </Grid>

          {/* Submit */}
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Add Beauty Post
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}

export default AddBeauty;
